import { Injectable } from '@angular/core'
import { AVACY_EVENT_TYPE, isAvacyEvent } from './avacy-cookie-banner-event.model'
import { BehaviorSubject } from 'rxjs'
import { ScriptLoaderService } from '@mycicero/ng-script-loader'
import { appConfig } from '../../../brands/_current/config/app-config'

export const FACEBOOK_VENDOR_ID = 'd116'
export const GOOGLE_ADV_VENDOR_ID = 755

export interface AvacyPreferences {
  customVendorIds: (number | string)[]
  iabVendorsIds: (number | string)[]
}

@Injectable({
  providedIn: 'root',
})
export class AvacyCookieBannerService {
  /**
   * List of scripts enabled by Avacy Cookie Banner. If list is not initialized, its value is null
   */
  avacyPreferences$ = new BehaviorSubject<AvacyPreferences | null>(null)

  constructor(private readonly scriptLoaderService: ScriptLoaderService) {}

  /**
   * Check if Avacy preference are already set and in that case enable all related tracking scripts
   */
  checkAvacyPreferences(): void {
    window.addEventListener(AVACY_EVENT_TYPE, (event) => {
      if (isAvacyEvent(event)) {
        this.avacyPreferences$.next({
          customVendorIds: event.detail.customVendorsWithConsent.map((vendor) => vendor.id),
          iabVendorsIds: event.detail.iabVendorsWithConsent.map((vendor) => vendor.id),
        })
      }
    })
  }

  /**
   * Init the Avacy Cookie Banner script
   */
  initAvacyCookieBanner(): void {
    this.scriptLoaderService.loadStyle('avacyCookie', { url: '../assets/avacy-cookie-banner.css' }).subscribe()
    this.scriptLoaderService
      .loadScript('avacyCookieBanner1', {
        innerHTML: ' ',
        attributes: {
          id: 'oil-configuration',
          type: 'application/configuration',
          'data-remote-config': appConfig.cookieBanner.avacyConfigUrl,
        },
        targetEl: 'head',
      })
      .subscribe()

    this.scriptLoaderService
      .loadScript('avacyCookieBanner2', {
        url: 'https://mooney.avacy-cdn.com/current/dist/oilstub.min.js',
        targetEl: 'head',
      })
      .subscribe()

    this.scriptLoaderService
      .loadScript('avacyCookieBanner3', {
        url: 'https://mooney.avacy-cdn.com/current/dist/oil.min.js',
        targetEl: 'head',
      })
      .subscribe()

    this.checkAvacyPreferences()
  }
}
